<label :class="{ horizontal: isHorizontal }"><span v-if="label">{{ label }}</span><slot></slot></label>